export function normalizeInput(input, protocol = 'https') {
  let s = input.trim();
  if (!s) throw new Error('Empty input');
  
  // If missing scheme, add it
  if (!/^https?:\/\//i.test(s)) {
    s = `${protocol}://${s}`;
  }
  
  try {
    const u = new URL(s);
    // Lowercase host, remove default ports
    u.hostname = u.hostname.toLowerCase();
    if ((u.protocol === 'https:' && u.port === '443') ||
        (u.protocol === 'http:' && u.port === '80')) {
      u.port = '';
    }
    return u.toString();
  } catch {
    throw new Error('Invalid URL/domain');
  }
}

export function getDomainFromUrl(url) {
  try {
    const u = new URL(url);
    return u.hostname;
  } catch {
    return url;
  }
}

export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
}

export function extractProtocol(url) {
  try {
    const u = new URL(url);
    return u.protocol.replace(':', '');
  } catch {
    return 'unknown';
  }
}